import { IProfile } from "@/types/IProfile";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ProfileDataSlice = {
    userProfile: IProfile
  };
  
  const initialState: ProfileDataSlice = {} as ProfileDataSlice;
  
  export const ProfileDataSlice = createSlice({
    name: "trenches_slice",
    initialState,
    reducers: { 
      setUserProfile: (state, action: PayloadAction<IProfile>) => {
        state.userProfile = action.payload;
      }
    }

  });


export const { setUserProfile } = ProfileDataSlice.actions;

  export default ProfileDataSlice.reducer;
